"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _loadingButton = _interopRequireDefault(require("./loadingButton"));
var _excluded = ["url", "onClick"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var TableCheckboxActionButton = exports["default"] = /*#__PURE__*/function (_Component) {
  function TableCheckboxActionButton(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, TableCheckboxActionButton);
    _this = _callSuper(this, TableCheckboxActionButton, [props]);
    _this.onClick = _this.onClick.bind(_this);
    _this.onCheckboxChanged = _this.onCheckboxChanged.bind(_this);
    _this.state = {
      disabled: true
    };
    return _this;
  }
  (0, _inherits2["default"])(TableCheckboxActionButton, _Component);
  return (0, _createClass2["default"])(TableCheckboxActionButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkboxes = $('td.select input[name=select]');
      this.checkboxes.change(this.onCheckboxChanged);
      this.onCheckboxChanged();
    }
  }, {
    key: "onCheckboxChanged",
    value: function onCheckboxChanged() {
      this.setState({
        disabled: this.checkboxes.filter(':checked').length === 0
      });
    }
  }, {
    key: "onClick",
    value: function onClick() {
      var checkboxes = this.checkboxes.filter(':checked');
      if (checkboxes.length === 0) {
        return;
      }
      var ids = [];
      checkboxes.each(function () {
        ids.push(parseInt($(this).val()));
      });
      if (this.props.onClick) {
        this.props.onClick(ids);
      } else {
        document.location = this.props.url + '?ids=' + _.join(ids, ',');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        url = _this$props.url,
        onClick = _this$props.onClick,
        rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_loadingButton["default"], (0, _extends2["default"])({
        color: "primary"
      }, rest, {
        disabled: this.state.disabled,
        onClick: this.onClick
      }));
    }
  }]);
}(_react.Component);